import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getZoneCreationError() {
      return getState().error;
    },
    isZoneCreationRequestFailure() {
      return getState().request.isFailure;
    },
    isZoneCreationRequestPending() {
      return getState().request.isPending;
    },
    isZoneCreationRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
